// Shared CSS for the modal family (KaModal + KaAlertModal).
//
// KaModal renders reka-ui's Dialog primitive and KaAlertModal renders the
// AlertDialog primitive, but both surfaces look identical. Keeping the class
// strings here — the same way KaButton/KaLink share `button-variants` — means
// the styling only ever needs to change in one place.

export const modalOverlayClasses = 'fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm';

export const modalContainerClasses =
  'fixed inset-0 flex items-center justify-center overflow-y-auto p-4';

export const modalContentClasses =
  'relative w-full max-w-lg transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all dark:bg-navy-900';

export const modalConfirmBodyClasses = 'px-4 pb-4 pt-5 text-left sm:p-6';

export const modalTitleClasses =
  'font-sans text-base font-semibold leading-6 text-gray-900 dark:text-gray-50';

export const modalDescriptionClasses = 'mt-2 text-sm text-gray-600 dark:text-gray-400';

export const modalButtonsGridClasses = 'grid gap-3 sm:mt-6 sm:grid-flow-row-dense sm:grid-cols-2';

// Vue <Transition> class bindings, shared so the open/close animation stays in
// sync across both surfaces.
export const modalOverlayTransition = {
  enterActiveClass: 'duration-300 ease-out',
  enterFromClass: 'opacity-0',
  enterToClass: 'opacity-100',
  leaveActiveClass: 'duration-200 ease-in',
  leaveFromClass: 'opacity-100',
  leaveToClass: 'opacity-0',
} as const;

export const modalContentTransition = {
  enterActiveClass: 'duration-300 ease-out',
  enterFromClass: 'opacity-0 scale-95',
  enterToClass: 'opacity-100 scale-100',
  leaveActiveClass: 'duration-200 ease-in',
  leaveFromClass: 'opacity-100 scale-100',
  leaveToClass: 'opacity-0 scale-95',
} as const;
